import { ChevronRight } from 'lucide-react';
import {Link, Route, Routes, useLocation} from "react-router-dom";

import { HOST_MB } from '@/lib/constants';
import { useCurrentUser } from '@/hooks/api/use-user';
import usePageTitle from '@/hooks/use-page-title';

import PromoBlocs from '@/pages/home/promo-blocs';

import Avantagesliste from "@/pages/avantages/avantagesliste";
import Certimat from "@/pages/avantages/certimat";
import Dekra from "@/pages/avantages/dekra";
import InMotion from "@/pages/avantages/in-motion";
import LibertyRider from "@/pages/avantages/liberty-rider";
import Sentidrive from "@/pages/avantages/sentidrive";

const Avantages = () => {
    usePageTitle('Mes avantages');
    const location = useLocation();
    const isEligibleParrainage = useCurrentUser().eligible_parrainage;

    const routeLabels: Record<string, string> = {
        '/mes-avantages/in&motion': 'In&Motion',
        '/mes-avantages/liberty-rider': 'Liberty Rider',
        '/mes-avantages/sentidrive': 'Sentidrive',
        '/mes-avantages/certimat': 'Certimat',
        '/mes-avantages/dekra-automotive': 'Dekra Automotive'
    };

    const currentLabel = routeLabels[location.pathname];

    return (
        <div className="w-full">
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                {currentLabel ? (
                    <>
                        <Link to="/mes-avantages" className="hover:text-foreground transition-colors no-underline">Mes avantages</Link>
                        <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                        <span className="text-foreground">{currentLabel}</span>
                    </>
                ) : (
                    <Link to="/mes-avantages" className="hover:text-foreground transition-colors no-underline">Mes avantages</Link>
                )}
            </nav>
            <div className="space-y-2 sm:space-y-3 mt-4">
                <h1 className="text-xl sm:text-2xl font-bold">{currentLabel || 'Mes avantages'}</h1>
            </div>

            <Routes>
                <Route index element={<Avantagesliste />} />
                <Route path={'in&motion'} element={<InMotion />} />
                <Route path={'liberty-rider'} element={<LibertyRider />} />
                <Route path={'sentidrive'} element={<Sentidrive />} />
                <Route path={'certimat'} element={<Certimat />} />
                <Route path={'dekra-automotive'} element={<Dekra />} />
            </Routes>

            {HOST_MB === 43397 && <div className="mt-6"><PromoBlocs isEligibleParrainage={isEligibleParrainage} /></div>}
        </div>
    );
};

export default Avantages;
